/**
 * The names a map's atmosphere may take in OdysseyTales (ADR-122 decision 6; its note "how P1.4-T135 is built",
 * item 6): the place-music folders under `music/` as they stand in the art store's `assets/source/audio/music`,
 * and the folders under `ambience/`. The menus' `title` folder is not a place's music. The map's music falls back
 * to its map group's and then to `shared/adventuring` (ADR-085 decision 13).
 */

/**
 * The music folders a map may name, in name order.
 */
export const MAP_MUSIC: readonly string[] = ["hubs/veranthos", "regions/ashenmoor", "regions/bleached-coast", "regions/echohalls", "regions/eld", "regions/splinterlands", "regions/thornwick", "regions/verdant-reach", "shared/adventuring", "shared/combat", "shared/tavern"];

/**
 * The ambience folders a map may name: none until the ambience row adds one.
 */
export const MAP_AMBIENCE: readonly string[] = [];
